/**
 * Generate Structured Data (JSON-LD) for SEO
 */
export function generateSchema({
  pageKey,
  title,
  metaTitle,
  metaDescription,
  canonicalUrl,
  heroImage,
  faqItems = [],
}) {
  const baseUrl = typeof window !== 'undefined' ? window.location.origin : 'https://dvbolig.dk'
  const logoUrl = 'https://assets.auxodev.dk/assets/cf6a3489-9db0-408d-9584-8086b110e180/727ae610-4996-4e0c-beb1-82ff74ac0cde.png'

  const businessSchema = {
    '@context': 'https://schema.org',
    '@type': 'HomeAndConstructionBusiness',
    '@id': `${baseUrl}/#business`,
    name: 'Tømrermester Daniel Vandet',
    alternateName: 'Daniel Vandet Tømrerfirma',
    description: 'Professionel tømrermester med fokus på solidt håndværk, renovering, nybyg, træarbejde, tagarbejde, vinduer, døre og gulve.',
    url: baseUrl,
    telephone: '+4520532767',
    email: 'dvbolig@hotmail.com',
    image: heroImage || logoUrl,
    logo: logoUrl,
    taxID: 'DK40509496',
    priceRange: '$$',
    address: {
      '@type': 'PostalAddress',
      streetAddress: 'Lyngvænget 73',
      addressLocality: 'Glyngøre',
      postalCode: '7870',
      addressRegion: 'Nordjylland / Midtjylland',
      addressCountry: 'DK',
    },
    geo: {
      '@type': 'GeoCoordinates',
      latitude: 56.7579,
      longitude: 8.8687,
    },
    areaServed: [
      { '@type': 'AdministrativeArea', name: 'Glyngøre' },
      { '@type': 'AdministrativeArea', name: 'Roslev' },
      { '@type': 'AdministrativeArea', name: 'Skive' },
      { '@type': 'AdministrativeArea', name: 'Thy' },
      { '@type': 'AdministrativeArea', name: 'Mors' },
      { '@type': 'AdministrativeArea', name: 'Salling' },
      { '@type': 'AdministrativeArea', name: 'Vinderup' },
    ],
    openingHoursSpecification: [
      {
        '@type': 'OpeningHoursSpecification',
        dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
        opens: '07:00',
        closes: '17:00',
      },
    ],
    sameAs: [],
  }

  const websiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    '@id': `${baseUrl}/#website`,
    url: baseUrl,
    name: 'Tømrermester Daniel Vandet',
    description: 'Professionelt tømrerarbejde i Glyngøre, Roslev, Skive, Mors og Thy',
    publisher: {
      '@id': `${baseUrl}/#business`,
    },
    inLanguage: 'da-DK',
  }

  const webPageSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    '@id': `${canonicalUrl}#webpage`,
    url: canonicalUrl,
    name: metaTitle || title,
    description: metaDescription,
    isPartOf: {
      '@id': `${baseUrl}/#website`,
    },
    inLanguage: 'da-DK',
    primaryImageOfPage: heroImage ? {
      '@type': 'ImageObject',
      url: heroImage,
    } : undefined,
  }

  const schemas = [businessSchema, websiteSchema, webPageSchema]

  // Add BreadcrumbList for non-home pages
  if (pageKey !== 'index') {
    schemas.push({
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: [
        {
          '@type': 'ListItem',
          position: 1,
          name: 'Forside',
          item: `${baseUrl}/`,
        },
        {
          '@type': 'ListItem',
          position: 2,
          name: title || metaTitle,
          item: canonicalUrl,
        },
      ],
    })
  }

  // Add FAQPage Schema if FAQ items exist
  if (faqItems && faqItems.length > 0) {
    schemas.push({
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: faqItems.map((item) => ({
        '@type': 'Question',
        name: item.question,
        acceptedAnswer: {
          '@type': 'Answer',
          text: item.answerHtml.replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim(),
        },
      })),
    })
  }

  return schemas
}
